"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var axios_1 = __importDefault(require("axios"));
var index_module_scss_1 = __importDefault(require("../../index.module.scss"));
var i18next_1 = require("i18next");
var public_key = "af_aaIxyzM4B9qxjQlzHnQ";
var id = "4817572";
var formURI = "https://api.convertkit.com/v3/forms/".concat(id, "/subscribe");
var tagsURI = "https://api.convertkit.com/v3/tags";
function GetStarted() {
    var _this = this;
    var _a = (0, react_1.useState)(""), name = _a[0], setName = _a[1];
    var _b = (0, react_1.useState)(""), email = _b[0], setEmail = _b[1];
    var _c = (0, react_1.useState)(0), artistType = _c[0], setArtistType = _c[1];
    var _d = (0, react_1.useState)(0), help = _d[0], setHelp = _d[1];
    var _e = (0, react_1.useState)(""), mainSocial = _e[0], setMainSocial = _e[1];
    var _f = (0, react_1.useState)(""), achieve = _f[0], setAchieve = _f[1];
    var _g = (0, react_1.useState)([]), tags = _g[0], setTags = _g[1];
    var _h = (0, react_1.useState)(false), fetched = _h[0], setFetched = _h[1];
    // Show a message after the user submit the form
    // or show error
    var _j = (0, react_1.useState)(false), error = _j[0], setError = _j[1];
    var _k = (0, react_1.useState)(false), message = _k[0], setMessage = _k[1];
    var _l = (0, react_1.useState)(false), loading = _l[0], setLoading = _l[1];
    var helpList = [
        {
            id: 1,
            text: "I'd like to learn more about Digital collectibles (NFTs)",
            value: 3616433,
        },
        {
            id: 2,
            text: "I'm new to NFTs and want to find out how to launch a collection",
            value: 3616434,
        },
        {
            id: 3,
            text: "know about NFTs and I'm interested in launching my own collection",
            value: 3616435,
        },
    ];
    var options = [
        { id: 1, text: "Musician", value: 3616424 },
        { id: 2, text: "Influencer", value: 3616426 },
        { id: 3, text: "Creator", value: 3616429 },
        { id: 4, text: "Sports Person", value: 3616430 },
        { id: 5, text: "Digital Artist", value: 3616431 },
    ];
    var submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    /*
                     * as soon as the button is pressed i'm going to set the loading icon to true
                     */
                    setLoading(true);
                    if (!help) return [3 /*break*/, 2];
                    /*
                     * This is for the form, grab all the data then submit to api.
                     * I wanted to show you this yesterday. Simple sunction using axios.
                     *
                     * In react you can set states for a field, meaning when a user types in the field you can save it.
                     * can use any type of data
                     */
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: "POST",
                            url: formURI,
                            data: {
                                api_key: public_key,
                                name: name,
                                email: email,
                                tags: [artistType, help],
                                fields: {
                                    main_social_account: mainSocial,
                                    what_are_you_trying_to_achieve: achieve,
                                },
                            },
                        })];
                case 1:
                    /*
                     * This is for the form, grab all the data then submit to api.
                     * I wanted to show you this yesterday. Simple sunction using axios.
                     *
                     * In react you can set states for a field, meaning when a user types in the field you can save it.
                     * can use any type of data
                     */
                    _a.sent();
                    setMessage(true);
                    return [3 /*break*/, 3];
                case 2:
                    setLoading(false);
                    setError(true);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, axios_1.default)({
                                method: "GET",
                                url: tagsURI + "?api_key=".concat(public_key),
                            })];
                        case 1:
                            res = _a.sent();
                            setTags(res.data.tags);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (tags.length == 0 && !fetched) {
            fetchData();
            setFetched(true);
        }
    }, [tags, fetched]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.getStarted, id: "getstarted" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.card }, { children: message ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.content }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ style: { textAlign: "center" } }, { children: "Success!" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", color: "#fff" } }, { children: (0, i18next_1.t)("formSentMessage") }))] }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.grid }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.content }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (0, i18next_1.t)("formTitle") }), (0, jsx_runtime_1.jsx)("p", { children: (0, i18next_1.t)("formSubTitle") })] })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, __assign({ className: index_module_scss_1.default.form }, { children: [error && ((0, jsx_runtime_1.jsx)("div", __assign({ style: { color: "rgb(255 51 51)", fontSize: "18px" } }, { children: (0, i18next_1.t)("formRequiredMessage") }))), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "name", onChange: function (e, _a) {
                                                var value = _a.value;
                                                return setName(value);
                                            }, type: "text", placeholder: "Name" }) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "email", onChange: function (e, _a) {
                                                var value = _a.value;
                                                return setEmail(value);
                                            }, type: "text", placeholder: "Email" }) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Select, { className: index_module_scss_1.default.dropdown, fluid: true, options: options, onChange: function (e, _a) {
                                            var value = _a.value;
                                            setArtistType(value);
                                        }, placeholder: (0, i18next_1.t)("formAristType") }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "mainSocial", onChange: function (e, _a) {
                                                var value = _a.value;
                                                return setMainSocial(value);
                                            }, type: "text", placeholder: (0, i18next_1.t)("formMainSocial") }) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Select, { className: index_module_scss_1.default.dropdown, fluid: true, options: helpList, onChange: function (e, _a) {
                                            var value = _a.value;
                                            setHelp(value);
                                        }, placeholder: (0, i18next_1.t)("formHelpList") }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "achieve", onChange: function (e, _a) {
                                                var value = _a.value;
                                                return setAchieve(value);
                                            }, type: "text", placeholder: (0, i18next_1.t)("formAchieve") }) })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Button, __assign({ loading: loading, type: "submit", onClick: function () { return submitForm(); } }, { children: [(0, i18next_1.t)("formSend"), " ", (0, jsx_runtime_1.jsx)("img", { src: "/send.png" })] }))] }))] }))) })) }) })) }));
}
exports.default = GetStarted;
